export const BUDGET_MODULE_PATHS = {
  entry: "/budget-entry",
  import: "/import-budget",
  resolver: "/budget-module",
  dashboard: "/budget-module/dashboard",
  mapping: "/budget-module/mapping",
  departments: "/budget-module/departments",
  planner: "/budget-module/planner",
  changeRequests: "/budget-module/change-requests",
};

export const BUDGET_MODULE_PAGE_LINKS = [
  {
    label: "Dashboard",
    path: BUDGET_MODULE_PATHS.dashboard,
  },
  {
    label: "Import Budget",
    path: BUDGET_MODULE_PATHS.import,
  },
  {
    label: "Mapping",
    path: BUDGET_MODULE_PATHS.mapping,
  },
  {
    label: "Departments",
    path: BUDGET_MODULE_PATHS.departments,
  },
  {
    label: "Planner",
    path: BUDGET_MODULE_PATHS.planner,
  },
  {
    label: "Change Request",
    path: BUDGET_MODULE_PATHS.changeRequests,
  },
];

export const SELECTED_BUDGET_MODULE_YEAR_KEY =
  "virgil_budget_portal_selected_year";
export const SELECTED_BUDGET_MODULE_PAGE_KEY =
  "virgil_budget_portal_selected_budget_module_page";
export const USER_PROGRESS_KEY = "virgil_budget_portal_user_progress";
